import React from 'react';
import { Box } from '@apia/theme';

const Spacer: React.FunctionComponent<{ level: number }> = ({ level }) => {
  return (
    <>
      {Array(level)
        .fill('')
        .map((_, i) => i)
        .map((current) => (
          <Box className="spacer" key={current} />
        ))}
    </>
  );
};

export default Spacer;
